import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'

import RewardsList from '../RewardsList'

import { setRedirectAfterAuth } from '../../../../modules/auth/actions/creators'

import {
  setProfileModalPage,
  displayProfileModal,
  setTransportationMall,
} from '../../../../modules/profile/actions/creators'

const mapStateToProps = reduxState => {
  const { auth, profile } = reduxState
  const { accessToken } = auth
  const { advanceAccount } = profile

  return {
    accessToken,
    advanceAccount,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setProfileModalPage,
      displayProfileModal,
      setRedirectAfterAuth,
      setTransportationMall,
    },
    dispatch,
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(RewardsList))
